import React from 'react';
import { FiLayout, FiZap, FiSmartphone } from 'react-icons/fi';
import Hero from '../../components/sections/Hero';
import AuditForm from '../../components/sections/AuditForm';
import SEO from '../../components/common/SEO';
import SafeIcon from '../../components/common/SafeIcon';
import { servicesData } from '../../data/services';

const WebDesign = () => {
  const data = servicesData['web-design'];

  return (
    <>
      <SEO title={`${data.title} | Alberta SEO Pro`} description={data.description} />
      <Hero title={data.title} subtitle={data.longDesc} />
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-slate-900">Websites Built for ROI</h2>
            <p className="text-slate-600 mt-4">We don't just make it look good—we make it work.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {[
              { icon: FiZap, title: "Blazing Fast Speed", desc: "Under 1-second load times to keep customers from leaving." },
              { icon: FiSmartphone, title: "Mobile-First", desc: "Perfect experience on iPhones and Android devices." },
              { icon: FiLayout, title: "Conversion Ready", desc: "Strategic CTA placement to maximize lead volume." }
            ].map((item, i) => (
              <div key={i} className="bg-white p-8 rounded-2xl shadow-sm">
                <SafeIcon icon={item.icon} className="text-3xl text-orange-600 mb-4" />
                <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                <p className="text-slate-600">{item.desc}</p>
              </div>
            ))}
          </div>
          <div className="max-w-3xl mx-auto">
            <AuditForm 
              type="Web Design"
              title="Free Conversion & Speed Audit"
              subtitle="Is your current website scaring away customers? Get a detailed technical report on your site's speed and conversion gaps."
              buttonText="Analyze My Website Speed"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default WebDesign;